import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Col } from "@vds/grids";
import { Tab, Tabs } from "@vds/tabs";
import InvoiceHistory from "../invoiceHistory/invoiceHistory";
import PaymentHistory from "../paymentHistory/paymentHistory";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { changeLanguage } from "../../util/userLanguageUtils";
import { FlexRow, FlexColumn, Wrapper } from "../../constants/common/StyledGlobalConstants";
import ManagePrimaryContactInvoice from "../ManagePrimaryContactInvoice";

const TabStyle = styled(Tabs)`
  position: relative;
`;

const getMarginRight = (language) => {
  if (!language) return "auto";
  if (language === "nl-Nl" || language === "de-DE") return "0rem !important";
  return "3rem";
};

const getOverflowWrap = (language) => {
  if (!language) return "normal";
  if (language === "nl-Nl" || language === "de-DE") return "anywhere";
  return "normal";
};

const TabListStyle = styled(Tab)`
  @media (max-width: 767px) {
    margin-right: 1rem !important;
  }
  @media (min-width: 768px) {
    margin-right: ${(props) => getMarginRight(props.language)};
  }
  @media (max-width: 767px) {
    overflow-wrap: ${(props) => getOverflowWrap(props.language)};
  }
`;

const IconCol = styled(Col)`
  text-align: right;
  padding: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

class InvoicePayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userLanguage: "",
      nameSpace: "",
    };
  }

  callFetchinvoice = (e, index) => {
    this.props.setTabIndex(index);
  };

  componentDidMount() {
    let language = this.props.userLanguage.replace(/-/g, "");
    this.setState({ userLanguage: language }, () => {
      this.setState((prevState) => {
        const nameSpace = changeLanguage(prevState.userLanguage, "leftNavigation");
        return { nameSpace };
      }, () => {
        this.props.i18n.changeLanguage(this.state.userLanguage);
      });
    });
  }
  getLanguage(userLanguage) {
    if (userLanguage === "nl-NL") return "nl-Nl";
    if (userLanguage === "de-DE") return "de-DE";
    return "";
  }
  render() {
    return (
      <React.Fragment>
        {this.props.viewInvoicesPermission !== false ? (
          <Wrapper
            style={{
              marginTop: "unset",
              borderTop: "unset",
              paddingLeft: "0px",
              width: "auto",
            }}
            flex="1 1 0%"
          >
            <FlexRow style={{ paddingLeft: 0 }} flex="0 1 auto" justifyContent="flex-start">
              <FlexColumn className="no-padding-lr" flexBasis="100%" maxWidth="100%" display="block">
                <TabStyle
                  indicatorPosition="bottom"
                  linePosition="bottom"
                  selectedIndex={this.props.tabIndex}
                  className="invoice-tab"
                  id="billingTab"
                  onTabChange={this.callFetchinvoice}
                >
                  <TabListStyle
                    language={this.getLanguage(this.props.userLanguage)}
                    uniqueId="billing-history-tab"
                    label={this.props.t("Billing history", { ns: `${this.state.nameSpace}` })}
                  >
                    <InvoiceHistory />
                  </TabListStyle>

                  <TabListStyle
                    language={this.getLanguage(this.props.userLanguage)}
                    uniqueId="payment-history-tab"
                    label={this.props.t("Payment history", { ns: `${this.state.nameSpace}` })}
                  >
                    <PaymentHistory paymentHistoryTab={this.props.tabIndex} />
                  </TabListStyle>

                  <TabListStyle
                    language={this.getLanguage(this.props.userLanguage)}
                    uniqueId="manage-invoice-tab"
                    label={this.props.t("Recipient list", { ns: `${this.state.nameSpace}` })}
                  >
                    <ManagePrimaryContactInvoice mipTab={this.props.tabIndex} />
                  </TabListStyle>
                </TabStyle>
              </FlexColumn>
              <IconCol colSizes={{ desktop: 1, tablet: 1, mobile: 1 }}></IconCol>
            </FlexRow>
          </Wrapper>
        ) : (
          <Wrapper
            style={{
              marginTop: "unset",
              borderTop: "unset",
              paddingLeft: "0px",
              width: "auto",
            }}
            flex="1 1 0%"
          >
            <FlexRow style={{ paddingLeft: 0 }} flex="0 1 auto" justifyContent="flex-start">
              <FlexColumn className="no-padding-lr" flexBasis="100%" maxWidth="100%" display="block">
                <TabStyle
                  indicatorPosition="bottom"
                  linePosition="bottom"
                  selectedIndex={this.props.tabIndex}
                  className="invoice-tab"
                  id="billingTab"
                  onTabChange={this.callFetchinvoice}
                >
                  <Tab
                    uniqueId="billing-history-tab"
                    label={this.props.t("Billing history", { ns: `${this.state.nameSpace}` })}
                  >
                    <InvoiceHistory />
                  </Tab>

                  <Tab
                    uniqueId="payment-history-tab"
                    label={this.props.t("Payment history", { ns: `${this.state.nameSpace}` })}
                  >
                    <PaymentHistory paymentHistoryTab={this.props.tabIndex} />
                  </Tab>
                </TabStyle>
              </FlexColumn>
              <IconCol colSizes={{ desktop: 1, tablet: 1, mobile: 1 }}></IconCol>
            </FlexRow>
          </Wrapper>
        )}
      </React.Fragment>
    );
  }
}

InvoicePayment.propTypes = {
  userLanguage: PropTypes.string,
  viewInvoicesPermission: PropTypes.bool,
  tabIndex: PropTypes.number,
  setTabIndex: PropTypes.func,
  t: PropTypes.func,
  i18n: PropTypes.object,
};

export default withTranslation([
  "accountTranslation",
  "billingTranslation",
  "headerTranslation",
  "navigationTranslation",
  "loginTranslation",
  "casesTranslation",
  "leftNavigationTranslation",
])(
  connect((state) => {
    return {
      userLanguage: state.ACCOUNT.userLanguage,
      regionId: state.ACCOUNT.regionId,
      windowSize: state.ACCOUNT.windowSize,
      viewInvoicesPermission: state.ACCOUNT.viewInvoicesPermission,
    };
  })(InvoicePayment)
);
